exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sound-share-shade-layer-modal .am-modal-content {\n  background: transparent;\n}\n.sound-share-shade-layer-modal .wxshare-modal-container .wxshare-arrow {\n  height: 100%;\n  width: 5.9375rem;\n  position: relative;\n  left: 17rem;\n  top: .625rem;\n}\n.sound-share-shade-layer-modal .wxshare-modal-container .wxshare-arrow img {\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true,"modifyVars":{"@brand-primary":"#A0B8FF"}}!./src/components/Sound/shareShadeLayer.less
// module id = 340
// module chunks = 150